<div class="main-content table-page detalle-area-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="queryTablero">Tablero BSC</a>
      <span aria-hidden="true">›</span>
      <span aria-current="page">{{ nombreArea || "Detalle de área" }}</span>
    </nav>

    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p>{{ resumen }}</p>
      </div>
      <div class="table-page__toolbar-actions detalle-area-bsc__acciones">
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           [routerLink]="ruta.tablero" [queryParams]="queryTablero">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          Tablero
        </a>
        <!-- El FOR-011 de esta planeación al corte elegido (exportar.do, F4.4). -->
        <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="puedeExportar" [disabled]="exportando || loading" [attr.aria-busy]="exportando"
                (click)="exportar()">
          <span class="material-icons" aria-hidden="true">{{ exportando ? "hourglass_top" : "download" }}</span>
          {{ exportando ? "Exportando…" : "Exportar FOR-011" }}
        </button>
        <!-- F6.5: el cierre del trimestre abierto (C3); «Volver» regresa aquí. -->
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           *ngIf="qCierre != null && !loading && detalle?.ejercicio?.idEjercicio != null"
           [routerLink]="[ruta.cierre, detalle?.ejercicio?.idEjercicio, qCierre]" [queryParams]="{ desde: 'area' }">
          <span class="material-icons" aria-hidden="true">task_alt</span>
          {{ textoCierre }}
        </a>
        <a mat-raised-button class="btn table-page__primary-btn" *ngIf="puedeComparar" [routerLink]="ruta.comparativo"
           [queryParams]="queryComparativo">
          <span class="material-icons" aria-hidden="true">compare_arrows</span>
          Comparar años
        </a>
      </div>
    </section>

    <div class="bsc-franja detalle-area-bsc__exportar" role="alert" *ngIf="errorExportar">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <span>{{ errorExportar }}</span>
    </div>

    <output class="d-block mb-3" *ngIf="mensajeSugerencia">{{ mensajeSugerencia }}</output>

    <app-selector-corte-bsc *ngIf="idBscArea != null" prefijo="bsc-area" [anio]="anioInicial" [corte]="corteInicial"
                            [deshabilitado]="loading || sugerenciaPendiente != null" (cambio)="onSeleccion($event)">
      <div meta class="tickets-toolbar__meta" *ngIf="corte">
        <span>{{ loading ? "Consultando…" : textoPlaneacion }}</span>
        <strong>{{ textoCorteMeta }}</strong>
      </div>
    </app-selector-corte-bsc>

    <section class="table-page__card" *ngIf="loading">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando el área</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="!loading && error">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar el área</h3>
        <p>{{ error }}</p>
      </div>
    </section>

    <ng-container *ngIf="!loading && !error && detalle">
      <!-- Un bloque que no se pudo leer o calcular. Con un estado vacío los avisos van
           dentro de su tarjeta: ahí son la explicación. -->
      <output class="bsc-franja detalle-area-bsc__avisos" *ngIf="avisos.length > 0 && estado === 'DATOS'">
        <span class="material-icons" aria-hidden="true">info</span>
        <ul>
          <li *ngFor="let aviso of avisos">{{ aviso }}</li>
        </ul>
      </output>

      <!-- ============================ Estados vacíos ============================ -->
      <section class="table-page__card detalle-area-bsc__vacio" *ngIf="estado !== 'DATOS'"
               aria-labelledby="detalle-area-bsc-vacio">
        <div class="table-page__empty">
          <ng-container [ngSwitch]="estado">
            <ng-container *ngSwitchCase="'SIN_LECTURA'">
              <span class="material-icons" aria-hidden="true">sync_problem</span>
              <h3 id="detalle-area-bsc-vacio">No se pudo leer el BSC de {{ anio }}</h3>
              <p>
                Una parte del año no se pudo consultar, así que no se sabe si {{ nombreArea }} tiene planeación. Los datos
                no se perdieron: vuelve a consultar en un momento.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_CICLO'">
              <span class="material-icons" aria-hidden="true">event_busy</span>
              <h3 [id]="'detalle-area-bsc-vacio'">{{ anio }} no tiene datos en el BSC</h3>
              <p>
                El año se da de alta en Parámetros (con sus fechas y umbrales) o al cargar el FOR-011 de un año anterior en
                modo histórico.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_PLANEACION'">
              <span class="material-icons" aria-hidden="true">assignment_late</span>
              <h3 [id]="'detalle-area-bsc-vacio'">{{ nombreArea }} no tiene planeación en {{ anio }}</h3>
              <p>
                Los KPIs, las metas y los pesos del año se arman en Planeación de metas o llegan con el FOR-011 del área.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'NO_AUTORIZADA'">
              <span class="material-icons" aria-hidden="true">pending_actions</span>
              <h3 [id]="'detalle-area-bsc-vacio'">La planeación {{ anio }} de {{ nombreArea }} está {{ textoEstatusPlaneacion }}</h3>
              <p>
                El avance se mide sobre metas autorizadas: hasta que Dirección la autorice no hay alcances. Abajo, sus KPIs
                y desde qué trimestre aplican.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_CORTE'">
              <span class="material-icons" aria-hidden="true">date_range</span>
              <h3 [id]="'detalle-area-bsc-vacio'">El corte anual de {{ anio }} todavía no tiene datos del área</h3>
              <p>El corte anual es el último trimestre autorizado del área. Elige Q1, Q2, Q3 o Q4 para ver el avance en vivo.</p>
            </ng-container>
          </ng-container>

          <ul class="detalle-area-bsc__vacio-avisos" *ngIf="avisos.length > 0">
            <li *ngFor="let aviso of avisos">{{ aviso }}</li>
          </ul>

          <div class="detalle-area-bsc__vacio-acciones" *ngIf="estado === 'SIN_LECTURA'">
            <button mat-raised-button type="button" class="btn table-page__primary-btn" (click)="consultar()">
              <span class="material-icons" aria-hidden="true">refresh</span>
              Volver a consultar
            </button>
          </div>
          <!-- Configurar, planear o cargar solo cuando se sabe que falta (no si no se pudo leer). -->
          <div class="detalle-area-bsc__vacio-acciones" *ngIf="estado !== 'SIN_CORTE' && estado !== 'SIN_LECTURA'">
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="estado === 'SIN_CICLO' && puedeConfigurar" [routerLink]="ruta.parametros">
              <span class="material-icons" aria-hidden="true">tune</span>
              Configurar {{ anio }}
            </a>
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="estado !== 'SIN_CICLO' && puedePlanear" [routerLink]="ruta.planeacion"
               [queryParams]="queryPlaneacion">
              <span class="material-icons" aria-hidden="true">event_note</span>
              Planeación de metas
            </a>
            <a mat-raised-button class="btn table-page__primary-btn"
               *ngIf="estado !== 'NO_AUTORIZADA' && puedeCargarExcel" [routerLink]="ruta.cargaExcel">
              <span class="material-icons" aria-hidden="true">upload_file</span>
              Cargar Excel FOR-011
            </a>
          </div>
        </div>
      </section>

      <!-- ============================ Tiles, gráfica y trimestres ============================ -->
      <div class="tickets-dashboard detalle-area-bsc__cuerpo" *ngIf="estado === 'DATOS'">
        <app-tiles-bsc [tiles]="tiles" etiqueta="Resumen del área"></app-tiles-bsc>

        <section class="detalle-area-bsc__graficas" aria-label="Avance por trimestre">
          <article class="tickets-card detalle-area-bsc__grafica">
            <div class="tickets-card__header">
              <div>
                <span>{{ anio }}</span>
                <h2>Programado vs real acumulado</h2>
              </div>
            </div>
            <app-acumulado-q-bsc [real]="detalle.serieRealQ" [programado]="detalle.serieProgramadoQ"
                                 nombreReal="Real acumulado del área"
                                 [descripcion]="'Alcance acumulado de ' + nombreArea + ' por trimestre en ' + anio">
            </app-acumulado-q-bsc>
            <p class="detalle-area-bsc__nota">
              Promedio de los KPI vigentes del área, como la hoja «Indicadores por Area».
              {{ q != null && q < 4 ? "Después del corte solo se ve lo programado." : "" }}
            </p>
          </article>

          <article class="tickets-card detalle-area-bsc__grafica" aria-labelledby="detalle-area-bsc-trimestres">
            <div class="tickets-card__header">
              <div>
                <span>Flujo del año</span>
                <h2 id="detalle-area-bsc-trimestres">Trimestres</h2>
              </div>
            </div>
            <ol class="detalle-area-bsc__trimestres">
              <li *ngFor="let t of filasTrimestre; trackBy: trackTrimestre" [class.is-corte]="t.esCorte">
                <div class="detalle-area-bsc__trimestre-q">
                  <strong>Q{{ t.q }}</strong>
                  <span class="bsc-oculto" *ngIf="t.esCorte">(trimestre del corte)</span>
                </div>
                <div class="detalle-area-bsc__trimestre-cuerpo">
                  <div class="detalle-area-bsc__trimestre-linea">
                    <span class="table-page__status-badge" *ngIf="t.estatus; else sinEstatus" [ngClass]="t.estatus.clase">
                      <span class="material-icons" aria-hidden="true">{{ t.estatus.icono }}</span>
                      {{ t.estatus.texto }}
                    </span>
                    <ng-template #sinEstatus><span class="table-page__subtext">—</span></ng-template>
                    <span class="detalle-area-bsc__trimestre-alcance">
                      <strong>{{ t.alcance }}</strong> de {{ t.programado }}
                      <span class="material-icons detalle-area-bsc__candado" *ngIf="t.congelado"
                            title="Congelado al autorizar el trimestre" aria-hidden="true">lock</span>
                      <span class="bsc-oculto" *ngIf="t.congelado">congelado al autorizar</span>
                    </span>
                  </div>
                  <p class="detalle-area-bsc__trimestre-nota" *ngIf="t.nota" [ngClass]="t.notaClase">{{ t.nota }}</p>
                  <p class="detalle-area-bsc__trimestre-detalle">
                    <span *ngFor="let m of t.movimientos">{{ m }}</span>
                    <span *ngIf="t.limite">{{ t.limite }}</span>
                  </p>
                </div>
              </li>
            </ol>
          </article>
        </section>
      </div>

      <!-- ============================ KPIs ============================ -->
      <section class="table-page__card bsc-bloque detalle-area-bsc__kpis"
               *ngIf="estado === 'DATOS' || estado === 'NO_AUTORIZADA' || estado === 'SIN_CORTE'"
               aria-labelledby="detalle-area-bsc-kpis">
        <header class="bsc-bloque__encabezado bsc-bloque__encabezado--acciones">
          <div>
            <h2 id="detalle-area-bsc-kpis">
              {{ estado === "NO_AUTORIZADA" ? "KPIs de la planeación" : "KPIs · acumulado por trimestre" }}
            </h2>
            <p *ngIf="estado !== 'NO_AUTORIZADA'">
              Acumulado real de cada KPI (columna L del FOR-011) hasta el corte; la barra marca con una raya lo
              programado. NA = el KPI no aplica en ese trimestre: no cuenta en el promedio del área hasta que aplica.
            </p>
            <p *ngIf="estado === 'NO_AUTORIZADA'">Sin avances hasta que la planeación se autorice.</p>
          </div>
          <mat-form-field appearance="outline" class="table-page__search-field detalle-area-bsc__buscar"
                          *ngIf="filas.length > 0">
            <mat-label>Buscar KPI</mat-label>
            <input matInput type="search" maxlength="80" [value]="filtro" aria-label="Buscar KPI"
                   (input)="onFiltro($any($event.target).value)" />
          </mat-form-field>
        </header>

        <div class="table-page__table-wrap" *ngIf="filasVisibles.length > 0; else sinKpis">
          <table class="table-page__table detalle-area-bsc__tabla">
            <thead>
              <tr>
                <th scope="col" class="detalle-area-bsc__col-objetivo">KPI</th>
                <th scope="col" class="detalle-area-bsc__num">Meta {{ anio }}</th>
                <th scope="col" class="detalle-area-bsc__num" *ngFor="let i of trimestres" [class.is-corte]="i === q">
                  Q{{ i }}<span class="bsc-oculto" *ngIf="i === q"> (corte)</span>
                </th>
                <th scope="col" class="detalle-area-bsc__col-barra" *ngIf="estado !== 'NO_AUTORIZADA'">
                  {{ q != null ? "Acumulado Q" + q : "Acumulado" }}
                </th>
                <th scope="col">Estado</th>
                <th scope="col" class="table-page__actions-head"><span class="bsc-oculto">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filasVisibles; trackBy: trackFila" [class.is-retirado]="f.retirado">
                <td class="detalle-area-bsc__col-objetivo">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name detalle-area-bsc__objetivo">{{ f.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="f.indicador">{{ f.indicador }}</span>
                  </div>
                </td>
                <td class="detalle-area-bsc__num">{{ f.meta }}</td>
                <td class="detalle-area-bsc__num" *ngFor="let c of f.celdas; let i = index" [ngClass]="c.clase"
                    [class.is-corte]="i + 1 === q">{{ c.texto }}</td>
                <td class="detalle-area-bsc__col-barra" *ngIf="estado !== 'NO_AUTORIZADA'">
                  <div class="detalle-area-bsc__barra" *ngIf="f.barra; else sinBarra">
                    <div class="detalle-area-bsc__pista" aria-hidden="true">
                      <i [ngClass]="f.barra.clase" [style.width.%]="f.barra.pista.ancho"></i>
                      <b class="bsc-raya" *ngIf="f.barra.pista.raya != null" [style.left.%]="f.barra.pista.raya"></b>
                    </div>
                    <span aria-hidden="true">{{ f.barra.texto }}</span>
                    <span class="cdk-visually-hidden">{{ f.barra.accesible }}</span>
                  </div>
                  <ng-template #sinBarra><span class="table-page__subtext">—</span></ng-template>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__status-badge bsc-badge-neutro" *ngIf="f.retirado">
                      <span class="material-icons" aria-hidden="true">block</span>
                      Retirado
                    </span>
                    <span class="table-page__status-badge" *ngIf="f.estado; else sinEstado" [ngClass]="f.estado.clase">
                      <span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>
                      {{ f.estado.texto }}
                    </span>
                    <ng-template #sinEstado>
                      <span class="table-page__subtext" *ngIf="!f.retirado">—</span>
                    </ng-template>
                    <span class="table-page__subtext" *ngIf="f.retirado">No entra al promedio en vivo</span>
                  </div>
                </td>
                <td class="detalle-area-bsc__accion">
                  <button type="button" mat-button aria-label="Sugerir para indicadores generales"
                    [attr.aria-pressed]="f.sugerido ?? false"
                    title="Sugerir para indicadores generales"
                    [disabled]="!puedeSugerir || cargandoSugerencias || f.sugerido == null || sugerenciaPendiente != null || f.idEjercicioKpi == null"
                    (click)="sugerir(f)">
                    <span class="material-icons" aria-hidden="true">{{ f.sugerido ? 'star' : 'star_border' }}</span>
                  </button>
                  <a class="table-page__link" *ngIf="f.idEjercicioKpi != null" [routerLink]="[ruta.kpi, f.idEjercicioKpi]"
                     [queryParams]="{ corte: corte, q: q }" [attr.aria-label]="f.etiquetaFicha">Ficha</a>
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="pie.length > 0 && !filtro">
              <tr>
                <th scope="row" class="detalle-area-bsc__col-objetivo">Alcance del área (promedio de KPIs vigentes)</th>
                <td></td>
                <td class="detalle-area-bsc__num" *ngFor="let c of pie; let i = index" [ngClass]="c.clase"
                    [class.is-corte]="i + 1 === q">
                  {{ c.texto }}
                  <span class="material-icons detalle-area-bsc__candado" *ngIf="congelados.includes(i + 1)"
                        title="Congelado al autorizar el trimestre" aria-hidden="true">lock</span>
                </td>
                <td class="detalle-area-bsc__col-barra">
                  <div class="detalle-area-bsc__barra" *ngIf="pieBarra; else sinPieBarra">
                    <div class="detalle-area-bsc__pista" aria-hidden="true">
                      <i [ngClass]="pieBarra.clase" [style.width.%]="pieBarra.pista.ancho"></i>
                      <b class="bsc-raya" *ngIf="pieBarra.pista.raya != null" [style.left.%]="pieBarra.pista.raya"></b>
                    </div>
                    <span aria-hidden="true">{{ pieBarra.texto }}</span>
                    <span class="cdk-visually-hidden">{{ pieBarra.accesible }}</span>
                  </div>
                  <ng-template #sinPieBarra><span class="table-page__subtext">—</span></ng-template>
                </td>
                <td colspan="2">
                  <span class="table-page__status-badge" *ngIf="pieSemaforo" [ngClass]="pieSemaforo.clase">
                    <span class="material-icons" aria-hidden="true">{{ pieSemaforo.icono }}</span>
                    {{ pieSemaforo.texto }}
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <p class="detalle-area-bsc__nota detalle-area-bsc__nota--tabla" *ngIf="congelados.length > 0 && !filtro">
          <span class="material-icons" aria-hidden="true">lock</span>
          El alcance del área de un trimestre autorizado es el que se congeló al autorizarlo; los demás se calculan en vivo.
          Por eso en esos trimestres el pie puede no ser el promedio exacto de la tabla.
        </p>

        <ng-template #sinKpis>
          <div class="table-page__empty">
            <ng-container *ngIf="!filtro && kpisSinLeer; else kpisVacios">
              <span class="material-icons" aria-hidden="true">sync_problem</span>
              <h3>No se pudieron leer los KPIs</h3>
              <p>La planeación sí existe; vuelve a consultar en un momento para ver sus KPIs.</p>
            </ng-container>
            <ng-template #kpisVacios>
              <span class="material-icons" aria-hidden="true">{{ filtro ? "search_off" : "list_alt" }}</span>
              <h3>{{ filtro ? "Ningún KPI coincide con la búsqueda" : "La planeación no tiene KPIs" }}</h3>
              <p *ngIf="!filtro">Los KPIs del año se dan de alta en Planeación de metas o llegan con el FOR-011 del área.</p>
            </ng-template>
          </div>
        </ng-template>
      </section>
    </ng-container>
  </div>
</div>
